import { useEffect, useState } from "react";
import { ParseJwt } from "../../../../core/utils/functions";

import Api from '../services/CodigosServices'
import { useForm } from "react-hook-form";

export const useCodigos = () => {
    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();
    const { register: registerSearch, handleSubmit: handleSubmitSearch, setValue: setValueSearch, reset: resetSearch, formState: { errors: errorsSearch } } = useForm();
    const { register: registerContrato, handleSubmit: handleSubmitContrato, setValue: setValueContrato, reset: resetContrato, formState: { errors: errorsContrato } } = useForm();

    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);
    const [loadingNewContrato, setLoadingNewContrato] = useState(false);
    const [loadingEliminarContratoo, setLoadingEliminarContrato] = useState(false);

    const [error, setError] = useState(false);
    const [data, setData] = useState([]);

    /**Modal */
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenModalContrato, setIsOpenModalContrato] = useState(false);
    const [currentFile, setCurrentFile] = useState("");
    const [dataSelected, setDataSelected] = useState([]);

    /***Paginador */
    const [inicioPagina, setInicioPagina] = useState(0);
    const [finPagina, setFinPagina] = useState(9);
    const [cambioPagina, setCambioPagina] = useState(5);
    const [paginador, setPaginador] = useState([]);
    const [cantPaginas, setCantPaginas] = useState(0);
    const [options, setOptions] = useState({
        limit: 10,
        offset: 0
    })

    const itemsPaginator = (cant) => {
        const num = cant || 1;
        return Array.from({ length: num }, (_, i) => i + 1);
    };

    const cambiarPagina = (limit = 5, currentIndex = 0) => {
        if (currentIndex) {
            const offset = (limit * currentIndex) - limit;
            setOptions(prevOptions => ({ ...prevOptions, offset }));

            let nuevoInicioPagina = currentIndex;

            if (cantPaginas - currentIndex < cambioPagina) {
                nuevoInicioPagina = cantPaginas - (cambioPagina + 1);
            } else if (currentIndex > 1) {
                nuevoInicioPagina = currentIndex - 2;
            }

            if (nuevoInicioPagina <= 1) {
                nuevoInicioPagina = 0;
            }

            setInicioPagina(nuevoInicioPagina);

            if (cantPaginas > 1) {
                let nuevoFinPagina = cantPaginas + 1;
                if (cantPaginas > (cambioPagina + 1)) {
                    nuevoFinPagina = (cambioPagina + 1) + nuevoInicioPagina;
                }
                setFinPagina(nuevoFinPagina);
            }

            loadData();
        }
    };

    function generateUniqueCode() {
        const now = new Date();

        const year = now.getFullYear().toString().slice(-2);
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        const randomPart = Math.floor(100 + Math.random() * 900);

        const uniqueCode = `${year}${month}${day}${seconds}${randomPart}`;

        return uniqueCode;
    }

    const handleGenerateCode = () => {
        const newCode = generateUniqueCode();
        setValue('codigo', newCode);
    };

    const handdleAddCode = async (datos) => {

        if (datos.archivo_contrato.length == 0) {
            showToast('Se debe seleccionar el contrato', "error");
            return;
        }

        const dataForm = new FormData();
        for (let i = 0; i < datos.archivo_contrato.length; i++) {
            dataForm.append('archivos', datos.archivo_contrato[i], datos.archivo_contrato[i].name);
        }

        dataForm.append("codigo", datos.codigo);
        dataForm.append("usuarioId", user.sub);

        const response = await Api.CrearCodigo(dataForm);

        reset();
        // setData([...data, response.data]);
        loadData();
    }

    const handdleNewContrato = async (datos) => {
        setLoadingNewContrato(true);

        if (datos.archivoContrato.length == 0) {
            showToast('Se debe seleccionar el contrato', "error");
            setLoadingNewContrato(false);
            return;
        }

        const dataForm = new FormData();
        for (let i = 0; i < datos.archivoContrato.length; i++) {
            dataForm.append('archivos', datos.archivoContrato[i], datos.archivoContrato[i].name);
        }

        dataForm.append("codigo", datos.codigo);
        dataForm.append("usuarioId", user.sub);

        const response = await Api.ActualizarContrato(dataForm, datos);
        if (!response.success) {
            setLoadingNewContrato(false);
            return;
        }

        setLoadingNewContrato(false);
        resetContrato();
        closeModalContrato();
        loadData();
    }

    const handdleEliminarCodigo = async (codigo) => {
        setLoadingEliminarContrato(true);

        const response = await Api.EliminarCodigo(codigo);
        if (!response.success) {
            setLoadingEliminarContrato(false);
            return;
        }

        setLoadingEliminarContrato(false);
        loadData();
    }

    const handdleEstado = async (data) => {
        setLoading(true);

        var response;

        if (data.activo == '1') {
            response = await Api.cambiarEstado(data, '0');
        } else {
            response = await Api.cambiarEstado(data, '1');
        }

        if (!response.success) {
            setLoading(false);
            return;
        }

        setLoading(false);
        loadData();
    }

    const handdleMarcarTerminado = async (data) => {
        setLoading(true);

        var response;

        if (data.activo == '1') {
            response = await Api.cambiarEstado(data, '2');
            if (!response.success) {
                setLoading(false);
                return;
            }
        } else if (data.activo == '2') {
            response = await Api.cambiarEstado(data, '1');
            if (!response.success) {
                setLoading(false);
                return;
            }
        }

        setLoading(false);
        loadData();
    }

    const loadData = async () => {
        setLoading(true);
        const response = await Api.ObtenerCodigos(options);
        if (!response.success) {
            setLoading(false);
            setError(true);
            return;
        }
        setData(response.data.datos);
        setPaginador(response.data);
        setLoading(false);
    }

    const openModal = (fileName) => {
        setIsOpen(true)
        setCurrentFile(fileName)
    };

    const closeModal = () => setIsOpen(false);

    const openModalContrato = (item) => {
        resetContrato();
        setDataSelected(item);
        setIsOpenModalContrato(true)
        setValueContrato('codigo', item.codigo)
    };

    const closeModalContrato = () => {
        setIsOpenModalContrato(false);
        setDataSelected([])
    }

    useEffect(() => {
        const dataUser = ParseJwt(localStorage.getItem('token'));
        setUser(dataUser);
        loadData().then();

        if (paginador?.pages) {
            setCantPaginas(paginador.pages);
        }

    }, [options]);

    useEffect(() => {

    }, [isOpen, currentFile]);

    return {
        state: {
            loading,
            loadingNewContrato
        },
        data: {
            data,
            user,
            error,
            isOpen,
            currentFile,
            isOpenModalContrato,
            dataSelected
        },
        form: {
            register, setValue, handleSubmit, errors, reset,
            registerSearch, handleSubmitSearch, setValueSearch, resetSearch, errorsSearch,
            registerContrato, handleSubmitContrato, setValueContrato, resetContrato, errorsContrato,
        },
        functions: {
            handdleEstado,
            closeModal,
            handdleAddCode,
            handleGenerateCode,
            openModal,
            handdleMarcarTerminado,
            openModalContrato,
            closeModalContrato,
            handdleNewContrato,
            handdleEliminarCodigo
        },
        paginador: {
            inicioPagina,
            finPagina,
            cambioPagina,
            paginador,
            cantPaginas,
            options,
            setOptions,
            cambiarPagina,
            itemsPaginator
        },
    }
}